import { SITE } from '@/app/constants';

/**
 * 首页案例视频/封面的 CDN 资源。国内站走 image01-aliyun.vidu.zone，海外站走 image01.cf.vidu.studio，
 * 文件名（含内容 hash）两端一致。集中在此，避免各组件重复写 SITE 分支。
 *
 * 位置约定：
 * - 首屏 HeroSection 轮播：Q41 / Q42 / S11
 * - 第二屏 GalleryScreen 首案例：Q43
 * - 第三屏 GalleryScreen 首案例：S12
 */
const CDN_BASE =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset'
    : 'https://image01.cf.vidu.studio/vidu/media-asset';

const asset = (name: string) => `${CDN_BASE}/${name}`;

export interface HomeMedia {
  videoSrc: string;
  poster: string;
}

export const HOME_MEDIA = {
  q41: {
    videoSrc: asset('vidu-video-3488283751768918-e040f238.mp4'),
    poster: asset('vidu-video-3488283751768918-0424137d.webp'),
  },
  q42: { videoSrc: asset('Q4-2-cd0293db.mp4'), poster: asset('Q4-2-ac3c9a92.webp') },
  q43: {
    videoSrc: asset('20260930-162913-50e833e5.mp4'),
    poster: asset('20260930-162913-2f478476.webp'),
  },
  s11: { videoSrc: asset('S11-cdefb97a.mp4'), poster: asset('S11-753ab643.webp') },
  s12: { videoSrc: asset('S12-ca6d5ddb.mp4'), poster: asset('S12-6c353cae.webp') },
} as const satisfies Record<string, HomeMedia>;
